/*!
 * chatbot-widget.js — Black Fashion sohbet balonu (Toserof).
 * Sağ altta balon; açılınca sohbet penceresi. Backend'e (tünel) POST atar.
 * Ayarlar theme.liquid içinde window.__CHATBOT__ ile verilir:
 *   { api: "https://<proje>.tunnel.patronundan.com.tr/api/chat", shop: "...", title, greeting, handoffUrl }
 */
(function () {
  "use strict";
  var CFG = window.__CHATBOT__ || {};
  if (!CFG.api) return; // backend adresi yoksa çalışma
  var SHOP = CFG.shop || "";
  // TOSEROF_I18N: EN sayfada arayüz metinleri İngilizce (bot cevapları backend'in dilindedir)
  var CB_EN = (document.documentElement.lang || "").toLowerCase().indexOf("en") === 0;
  var CB_T = CB_EN ? {
    open: "Open chat", close: "Close", placeholder: "Type your message...", send: "Send",
    handoff: "Contact customer service", typing: "typing",
    connErr: "Connection error. Please try again shortly."
  } : {
    open: "Sohbeti aç", close: "Kapat", placeholder: "Mesajınızı yazın...", send: "Gönder",
    handoff: "Müşteri hizmetlerine bağlan", typing: "yazıyor",
    connErr: "Bağlantı hatası oluştu. Lütfen biraz sonra tekrar deneyin."
  };
  var TITLE = CFG.title || (CB_EN ? "Support Assistant" : "Yardımcı Asistan");
  var HANDOFF_URL = CFG.handoffUrl || ""; // örn. WhatsApp / iletişim linki (varsa buton çıkar)

  // ---- Oturum + geçmiş (20 dk hareketsizlikte sıfırlanır) ----
  var TTL = 20 * 60 * 1000;
  var sid = "", history = [];
  try {
    var last = parseInt(localStorage.getItem("tsrf_last") || "0", 10);
    if (last && Date.now() - last > TTL) { localStorage.removeItem("tsrf_sid"); localStorage.removeItem("tsrf_hist"); localStorage.removeItem("tsrf_last"); }
    sid = localStorage.getItem("tsrf_sid");
    if (!sid) { sid = "w" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); localStorage.setItem("tsrf_sid", sid); }
    var h = JSON.parse(localStorage.getItem("tsrf_hist") || "[]");
    if (Array.isArray(h)) history = h;
  } catch (e) {}
  function persist() { try { localStorage.setItem("tsrf_hist", JSON.stringify(history.slice(-20))); localStorage.setItem("tsrf_last", String(Date.now())); localStorage.setItem("tsrf_sid", sid); } catch (e) {} }

  var busy = false;
  var opened = false;

  // ---- Stil ----
  var css =
    ".tsrf-chat *{box-sizing:border-box}" +
    // WhatsApp balonunun (Carthike, ~44px, bottom:16) ÜSTÜNE istifle, boyu eşitle
    ".tsrf-fab{position:fixed;right:16px;bottom:74px;width:46px;height:46px;border-radius:50%;background:#111;color:#fff;border:none;cursor:pointer;box-shadow:0 6px 20px rgba(0,0,0,.25);z-index:2147483000;display:flex;align-items:center;justify-content:center;transition:transform .15s}" +
    ".tsrf-fab:hover{transform:scale(1.06)}" +
    ".tsrf-fab svg{width:22px;height:22px}" +
    ".tsrf-panel{position:fixed;right:16px;bottom:130px;width:360px;max-width:calc(100vw - 24px);height:500px;max-height:calc(100vh - 150px);background:#fff;border-radius:14px;box-shadow:0 12px 40px rgba(0,0,0,.28);z-index:2147483000;display:none;flex-direction:column;overflow:hidden;font-family:inherit}" +
    ".tsrf-panel.open{display:flex}" +
    ".tsrf-head{background:#111;color:#fff;padding:14px 16px;display:flex;align-items:center;justify-content:space-between;font-weight:600;font-size:15px}" +
    ".tsrf-head button{background:transparent;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1}" +
    ".tsrf-body{flex:1;overflow-y:auto;padding:14px;background:#f7f7f8;display:flex;flex-direction:column;gap:10px}" +
    ".tsrf-msg{max-width:85%;padding:9px 12px;border-radius:12px;font-size:13.5px;line-height:1.45;white-space:pre-wrap;word-wrap:break-word}" +
    ".tsrf-bot{align-self:flex-start;background:#fff;color:#222;border:1px solid #eee;border-bottom-left-radius:4px}" +
    ".tsrf-user{align-self:flex-end;background:#111;color:#fff;border-bottom-right-radius:4px}" +
    ".tsrf-msg a{color:inherit;text-decoration:underline}" +
    ".tsrf-bot a{color:#c0392b}" +
    ".tsrf-typing{align-self:flex-start;background:#fff;border:1px solid #eee;border-radius:12px;border-bottom-left-radius:4px;padding:11px 14px;display:flex;gap:5px;align-items:center}" +
    ".tsrf-typing span{width:7px;height:7px;border-radius:50%;background:#b0b0b0;display:inline-block;animation:tsrfBounce 1.2s infinite ease-in-out}" +
    ".tsrf-typing span:nth-child(2){animation-delay:.18s}.tsrf-typing span:nth-child(3){animation-delay:.36s}" +
    "@keyframes tsrfBounce{0%,65%,100%{transform:translateY(0);opacity:.45}30%{transform:translateY(-5px);opacity:1}}" +
    ".tsrf-handoff{align-self:flex-start;margin-top:2px}" +
    ".tsrf-handoff a{display:inline-block;background:#25D366;color:#fff;padding:8px 12px;border-radius:8px;font-size:13px;text-decoration:none;font-weight:600}" +
    ".tsrf-foot{display:flex;gap:8px;padding:10px;border-top:1px solid #eee;background:#fff}" +
    ".tsrf-foot input{flex:1;border:1px solid #ddd;border-radius:20px;padding:9px 14px;font-size:14px;outline:none}" +
    ".tsrf-foot input:focus{border-color:#111}" +
    ".tsrf-foot button{background:#111;color:#fff;border:none;border-radius:20px;padding:0 16px;cursor:pointer;font-size:14px;font-weight:600}" +
    ".tsrf-foot button:disabled{opacity:.5;cursor:default}" +
    "@media(max-width:480px){.tsrf-panel{right:8px;left:8px;width:auto;bottom:126px;height:64vh}}";
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  // ---- DOM ----
  var root = document.createElement("div");
  root.className = "tsrf-chat";
  root.innerHTML =
    '<button class="tsrf-fab" aria-label="' + CB_T.open + '">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>' +
    "</button>" +
    '<div class="tsrf-panel" role="dialog" aria-label="Sohbet">' +
    '<div class="tsrf-head"><span>' + esc(TITLE) + '</span><button class="tsrf-close" aria-label="' + CB_T.close + '">×</button></div>' +
    '<div class="tsrf-body"></div>' +
    '<div class="tsrf-foot"><input type="text" placeholder="' + CB_T.placeholder + '" aria-label="Mesaj" maxlength="500"><button class="tsrf-send">' + CB_T.send + '</button></div>' +
    "</div>";
  document.body.appendChild(root);

  var fab = root.querySelector(".tsrf-fab");
  var panel = root.querySelector(".tsrf-panel");
  var body = root.querySelector(".tsrf-body");
  var input = root.querySelector(".tsrf-foot input");
  var sendBtn = root.querySelector(".tsrf-send");

  fab.addEventListener("click", toggle);
  root.querySelector(".tsrf-close").addEventListener("click", toggle);
  sendBtn.addEventListener("click", send);
  input.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });

  function toggle() {
    opened = !opened;
    panel.classList.toggle("open", opened);
    if (opened) {
      if (!body.childElementCount) {
        // Hazır karşılama kalıbı YOK (Hasan Bey kararı): 20 dk içinde geçmiş varsa göster; yoksa panel boş açılır, kullanıcı direkt yazar.
        if (history.length) history.forEach(function (m) { m.role === "user" ? addUser(m.text) : addBot(m.text); });
      }
      setTimeout(function () { input.focus(); }, 100);
    }
  }

  function esc(s) { var d = document.createElement("div"); d.textContent = String(s == null ? "" : s); return d.innerHTML; }

  // Basit markdown/link render: [x](url), çıplak url, **kalın**
  function render(text) {
    var h = esc(text);
    h = h.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    h = h.replace(/(^|[^"(])(https?:\/\/[^\s<]+)/g, '$1<a href="$2" target="_blank" rel="noopener">$2</a>');
    h = h.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    return h;
  }

  function scroll() { body.scrollTop = body.scrollHeight; }

  function addBot(text) {
    var d = document.createElement("div"); d.className = "tsrf-msg tsrf-bot"; d.innerHTML = render(text);
    body.appendChild(d); scroll();
  }
  function addUser(text) {
    var d = document.createElement("div"); d.className = "tsrf-msg tsrf-user"; d.textContent = text;
    body.appendChild(d); scroll();
  }
  function addHandoff() {
    if (!HANDOFF_URL) return;
    var w = document.createElement("div"); w.className = "tsrf-handoff";
    w.innerHTML = '<a href="' + esc(HANDOFF_URL) + '" target="_blank" rel="noopener">' + CB_T.handoff + '</a>';
    body.appendChild(w); scroll();
  }

  function send() {
    var msg = (input.value || "").trim();
    if (!msg || busy) return;
    input.value = "";
    addUser(msg);
    history.push({ role: "user", text: msg }); persist();
    busy = true; sendBtn.disabled = true;
    var typing = document.createElement("div"); typing.className = "tsrf-typing"; typing.setAttribute("aria-label", CB_T.typing); typing.innerHTML = "<span></span><span></span><span></span>";
    body.appendChild(typing); scroll();

    var reqBody = JSON.stringify({ sid: sid, shop: SHOP, message: msg });
    function attempt(url) {
      return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: reqBody })
        .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); });
    }
    // Önce App Proxy (/apps/chat, same-origin + giriş kimliği); olmazsa tünele düş
    attempt(CFG.api)
      .catch(function () { if (CFG.apiFallback && CFG.apiFallback !== CFG.api) return attempt(CFG.apiFallback); throw new Error("fail"); })
      .then(function (data) {
        typing.remove();
        var reply = (data && data.reply) || "Üzgünüm, şu an yanıt veremiyorum.";
        addBot(reply);
        history.push({ role: "model", text: reply }); persist();
        if (data && data.handoff) addHandoff();
      })
      .catch(function () {
        typing.remove();
        addBot(CB_T.connErr);
      })
      .finally(function () { busy = false; sendBtn.disabled = false; input.focus(); });
  }
})();
